<template>
  <div class="wt2-tabs" :class="type">
    <div
      v-if="currentTab"
      class="wt2-tabs-active-border"
      :class="currentTab.classes && currentTab.classes.backgroundColor"
      :style="borderStyleObj"
    />
    <div class="wt2-tabs-menu" ref="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        @click="selectTab(tab)"
        class="wt2-tabs-menu-tab"
        :class="[
          tab.id === computedTabId ? 'selected' : '',
          tab.classes && tab.classes.fontSize,
        ]"
      >
        <slot name="tab" :tab="tab">
          <!-- fallback content here -->
          <span v-if="tab.icon" class="wticon" :class="tab.icon" />
          <button
            class="wt2-tabs-menu-tab-button reserve-space"
            :data-text="tab.label"
            :disabled="tab.disabled"
            v-text="tab.label"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },

    currentTabId: {
      type: [String, Number],
    },

    type: {
      type: String,
      default: 'horizontal up',
    },
  },

  created() {
    if (this.currentTabId) {
      this.activeTabId = this.currentTabId;
    }
  },

  mounted() {
    this.setActiveBorderStyleNextTick();
  },

  data() {
    return {
      activeTabId: null,
      borderStyleObj: {},
    };
  },

  watch: {
    currentTabId(newVal) {
      this.activeTabId = newVal;
    },

    computedTabId() {
      this.setActiveBorderStyleNextTick();
    },
  },

  computed: {
    currentTab() {
      return this.tabs.find((tab) => tab.id === this.computedTabId);
    },

    computedTabId() {
      if (!this.activeTabId) {
        const firstTabNotDisabled = this.tabs.find((tab) => !tab.disabled);
        return firstTabNotDisabled && firstTabNotDisabled.id;
      }

      return this.activeTabId;
    },
  },

  methods: {
    setActiveBorderStyleNextTick() {
      this.$nextTick(() => {
        this.setActiveBorderStyle();
      });
    },

    selectTab(tab) {
      this.activeTabId = tab.id;
      this.$emit('tab-selected', tab);
    },

    setActiveBorderStyle() {
      if (this._isDestroyed) {
        return;
      }
      const selectedTab = this.$refs?.tabs?.querySelector('.selected');

      if (!selectedTab) {
        return;
      }

      const borderStyleObj = {};

      if (/horizontal/i.test(this.type)) {
        borderStyleObj.width = `${selectedTab.clientWidth}px`;
        borderStyleObj.transform = `translateX(${selectedTab.offsetLeft}px)`;
      } else if (/vertical/i.test(this.type)) {
        borderStyleObj.height = `${selectedTab.clientHeight}px`;
        borderStyleObj.transform = `translateY(${selectedTab.offsetTop}px)`;
      }

      this.borderStyleObj = borderStyleObj;
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'style_guide/_sg_mixins.scss';

.wt2-tabs {
  position: relative;

  &.horizontal {
    .wt2-tabs-menu {
      flex-direction: row;
    }
    .wt2-tabs-active-border {
      height: 2px;
      transition: transform 0.2s ease-out, height 0.3s;
    }
  }

  &.vertical {
    .wt2-tabs-menu {
      flex-direction: column;
    }

    .wt2-tabs-active-border {
      width: 2px;
      transition: transform 0.2s ease-out, width 0.3s;
    }
  }

  &.up {
    .wt2-tabs-active-border {
      top: 0;
    }
  }

  &.bottom {
    .wt2-tabs-active-border {
      bottom: -1px;
    }
  }

  .wt2-tabs-menu {
    padding: 0;
    display: flex;
    height: 35px;
    .wticon {
      &.favorite-tab-icon {
        margin-top: -2px;
        margin-right: 5px;
      }
      &.kaltura-icon {
        margin-right: 4px;
      }
      font-size: 20px;
      margin-right: 10px;
    }

    .wt2-tabs-menu-tab {
      transition: font-weight 0.2s;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      button {
        padding: 0;
      }

      &:hover,
      &.selected {
        font-weight: 500;
      }
    }

    .wt2-tabs-menu-tab-button {
      height: unset;
      background-color: transparent;
    }

    .reserve-space {
      @include reserve-space(700);
    }
  }

  .wt2-tabs-active-border {
    position: absolute;
  }
}
</style>
